export default __webpack_public_path__ + "static/media/paragraph.39a88682.svg";